/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Metadata_LabelInputs */

const en_paste_attributes_metadata_label = /** @type {(inputs: Paste_Attributes_Metadata_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata`)
};

const fr_paste_attributes_metadata_label = /** @type {(inputs: Paste_Attributes_Metadata_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadonnees`)
};

const de_paste_attributes_metadata_label = /** @type {(inputs: Paste_Attributes_Metadata_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadaten`)
};

const it_paste_attributes_metadata_label = /** @type {(inputs: Paste_Attributes_Metadata_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadati`)
};

const ru_paste_attributes_metadata_label = /** @type {(inputs: Paste_Attributes_Metadata_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метаданные`)
};

const es_paste_attributes_metadata_label = /** @type {(inputs: Paste_Attributes_Metadata_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatos`)
};

const zh_cn2_paste_attributes_metadata_label = /** @type {(inputs: Paste_Attributes_Metadata_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元数据`)
};

const ja_paste_attributes_metadata_label = /** @type {(inputs: Paste_Attributes_Metadata_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータ`)
};

const hi_paste_attributes_metadata_label = /** @type {(inputs: Paste_Attributes_Metadata_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडाटा`)
};

const pt_pt2_paste_attributes_metadata_label = /** @type {(inputs: Paste_Attributes_Metadata_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadados`)
};

/**
* | output |
* | --- |
* | "Metadata" |
*
* @param {Paste_Attributes_Metadata_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_metadata_label = /** @type {((inputs?: Paste_Attributes_Metadata_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Metadata_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_paste_attributes_metadata_label(inputs)
	if (locale === "de") return de_paste_attributes_metadata_label(inputs)
	if (locale === "it") return it_paste_attributes_metadata_label(inputs)
	if (locale === "ru") return ru_paste_attributes_metadata_label(inputs)
	if (locale === "es") return es_paste_attributes_metadata_label(inputs)
	if (locale === "zh-CN") return zh_cn2_paste_attributes_metadata_label(inputs)
	if (locale === "ja") return ja_paste_attributes_metadata_label(inputs)
	if (locale === "hi") return hi_paste_attributes_metadata_label(inputs)
	if (locale === "pt-PT") return pt_pt2_paste_attributes_metadata_label(inputs)
	return en_paste_attributes_metadata_label(inputs)
});